import types from './types';

const INITIAL_STATE = {
    isFetching: false,
    isUpdating: false,

  result: [],
};

const claimPortalReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PORTAL_CLAIM_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_PORTAL_CLAIM_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_PORTAL_CLAIM_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    default:
      return state;
  }
};

export default claimPortalReducer;
